import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "video-player-container",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("iframe", {
      src: `https://www.nanoo.tv/link/w/${_ctx.clientId}`,
      frameborder: "0",
      allow: "autoplay; fullscreen",
      allowfullscreen: "",
      scrolling: "no",
      sandbox: "allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-storage-access-by-user-activation",
      class: "video-player-iframe",
      style: _normalizeStyle(_ctx.iframeStyle)
    }, null, 12, _hoisted_1)
  ], 4))
}